import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewContainerRef, computed, inject, input } from '@angular/core';

import { SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { TimerModule } from '../../../timers/timer.module';
import { PodEventsModel } from '../../popular-bets.models';

@Component({
    selector: 'ms-popular-bets-bet-builder-plus-pod-header',
    standalone: true,
    imports: [TimerModule],
    templateUrl: './popular-bets-bet-builder-plus-pod-header.component.html',
    styleUrl: './popular-bets-bet-builder-plus-pod-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularBetsBetBuilderPlusPodHeaderComponent implements OnInit {
    @ViewChild('badgeContainer', { read: ViewContainerRef }) container: ViewContainerRef;

    pod = input.required<PodEventsModel>();
    titleColor = input<string | undefined>();

    private sitecorePopularBetsConfig = inject(SitecorePopularBetsConfig);

    eventTitle = computed(() => {
        if (this.pod().title) {
            return this.pod().title;
        }
        return this.getLeagueOrSportName('league') || this.getLeagueOrSportName('sport') || this.sitecorePopularBetsConfig.messages.MultiSport;
    });

    ngOnInit(): void {
        this.loadSGPPlusBadgeComponent();
    }

    private async loadSGPPlusBadgeComponent(): Promise<void> {
        const { SGPPlusBadgeComponent } = await import('../../../betbuilder/components/badge/sgp-plus-badge/sgp-plus-badge.component');
        this.container.clear();
        this.container.createComponent(SGPPlusBadgeComponent);
    }

    private getLeagueOrSportName(type: 'league' | 'sport'): string {
        const events = this.pod().events;
        const podTitle = events[0][type].name;

        for (let i = 1; i < events.length; i++) {
            const currentTitle = events[i][type].name;
            if (currentTitle !== podTitle) {
                return '';
            }
        }

        return podTitle;
    }
}
